
import styled from "styled-components";
import { transition, colors } from "oolib";

export const StyledFlexWrapper = styled.div`
  display: flex;
  overflow: hidden;
`;

export const StyledFlexItem = styled.div`
  flex-shrink: 0;
  width: 100%;
  margin-left: ${({ marginLeft }) => marginLeft};
  ${transition("margin-left")};
`;



export const StyledGallery = styled.div`
  padding-top: 1rem;
  border-top: 2px solid ${({ invert})=> invert ? colors.greyColor90 : colors.greyColor5};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;